import { render, staticRenderFns } from "./apps-page.vue?vue&type=template&id=5e6fe436&scoped=true"
import script from "./apps-page.vue?vue&type=script&lang=js"
export * from "./apps-page.vue?vue&type=script&lang=js"
import style0 from "./apps-page.vue?vue&type=style&index=0&id=5e6fe436&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e6fe436",
  null
  
)

export default component.exports